var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAddusers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.59995 12.8C7.17355 12.8 5.19995 10.8264 5.19995 8.4C5.19995 5.9736 7.17355 4 9.59995 4C12.0264 4 14 5.9736 14 8.4C14 10.8264 12.0264 12.8 9.59995 12.8Z",
    stroke: "#DADADA",
    strokeWidth: 1.2,
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 19.5H3.2C2.76 19.5 2.4 19.14 2.4 18.7C2.4 18.66 2.408 17.62 3.18 16.58C3.64 15.96 4.28 15.46 5.08 15.1C6.08 14.66 7.34 14.4 9.6 14.4C11.86 14.4 13.12 14.66 14.12 15.1C14.92 15.46 15.56 15.96 16.02 16.58C16.792 17.62 16.8 18.66 16.8 18.7C16.8 19.14 16.44 19.5 16 19.5Z",
    stroke: "#DADADA",
    strokeWidth: 1.2,
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 2V8M16.5 5H22.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddusers);
export default __webpack_public_path__ + "static/media/add users.3de08e762f86dab3e8d6b60ac6b301f2.svg";
export { ForwardRef as ReactComponent };